import { render, staticRenderFns } from "./VCardTemplate.vue?vue&type=template&id=79b6e1da&scoped=true&"
import script from "./VCardTemplate.vue?vue&type=script&lang=ts&"
export * from "./VCardTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./VCardTemplate.vue?vue&type=style&index=0&id=79b6e1da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b6e1da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCardActions,VCol,VRow,VSubheader})
